<template>
  <a-modal
    :visible="visible"
    :footer="null"
    @cancel="closeModal"
    wrapClassName="invite-category-modal"
    :header="null"
  >
    <div ref="addNewTopicBody" class="invite-category">
      <h2 class="invite-category__title">Invite Contacts</h2>
      <div v-if="skeletonLoader" class="invite-category__skeleton">
        <a-skeleton
          class="invite-category__skeleton--input-skeleton"
          active
          :title="{ width: '100%' }"
          :paragraph="null"
        />
        <a-skeleton
          v-for="index in 3" :key="index"
          class="invite-category__skeleton--user-skeleton"
          active
          :title="{ width: '100%' }"
          :paragraph="{
            rows: 2,
            width: ['70%', '30%'],
          }"
        />
        <br />
        <a-skeleton
          class="invite-category__skeleton--input-skeleton"
          active
          :title="{ width: '100%' }"
          :paragraph="null"
        />
      </div>
      <template v-else>
        <div class="invite-category__body">
          <template v-if="inviteType === 'topicInvite'">
            <manage-topics-roles 
              v-click-outside="handleClickOutside" 
              ref="manageTopicRolesOnInviteTopicCollaboration" 
              :userOptions="contactsOptions" 
              @pendingOrUpdateUsers="fetchUpdateTopicMembers"
              @fetchSelectedUser="fetchNewlyAddedTopicMembers"
              :topicType="audienceChoice"
              module="InviteTopicCollaboration"
              :preSelectedUsers="preSelectedUsers"
              @searchUser="searchUser"
              :searchLoader="searchUserLoader"
            />
            <topic-invite-via-email v-if="(selectedTopic?.permission === 'admin' && selectedTopic?.is_private) || !selectedTopic?.is_private" @changeSelectedUsers="fetchedEmail" :topicType="audienceChoice"/>
          </template>
          <template v-else>
            <TagifyContacts
              placeholder="Invite via Glocal"
              :options="options"
              @searchChange="fetchAllUsers"
              @fetchSelection="fetchedSelection"
              workingOn="connections"
              :isSubmitted="isSubmit"
              :id="randomId"
              :removeFields="emptyTagifyInput"
              :module="inviteType !== 'topicInvite' ? 'folder' : 'topic'"
            ></TagifyContacts>
            <tagify-email
              v-if="inviteType !== 'folderInvite'"
              placeholder="Invite via Email"
              @fetchEmail="fetchedEmail"
              :isSubmitted="isSubmit"
              :nullify="emptyTagifyInput"
            ></tagify-email>
          </template>
          <p class="label">Message <span>(optional)</span></p>
          <a-textarea
            v-model:value="inviteMessage"
            placeholder="Please enter message"
            rows="3"
            class="textarea"
          >
          </a-textarea>
          <p v-if="FieldErr" class="error">Enter atleast one field</p>
        </div>
      </template>
      <div class="invite-category__footer">
        <a-button
          :loading="loader"
          @click="inviteType === 'topicInvite' ? inviteCategory() : inviteToFolder()"
          class="btn">
          Submit
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import TagifyContacts from "./TagifyContacts.vue";
import TagifyEmail from "./TagifyEmail.vue";
import { mapActions } from "vuex";
import ManageTopicsRoles from "../BaseComponents/sourcesFilters/ManageTopicsRoles.vue";
import TopicInviteViaEmail from "../BaseComponents/TopicManagement/TopicInviteViaEmail.vue";
import { mapGetters } from "vuex";
export default {
  props: {
    visible: Boolean,
    categoryOptions: Array,
    categoryId: String,
    selectedTopic: Object,
    interestGroupId: String,
    options: Array,
    inviteType:{
      type: String,
      default : () => ('topicInvite')
    },
  },
  components: {
    TagifyContacts,
    TagifyEmail,
    ManageTopicsRoles,
    TopicInviteViaEmail
  },
  computed:{
    ...mapGetters({
        getFriends: 'profile/getFriends',
        topicNonInvitedUsers : 'discover/topicNonInvitedUsers'
        // getDiscussionInvitedUsers: 'discussion/getDiscussionInvitedUsers',
    }),
    isSubmit(){
      return this.isSubmitted
    },
    isAuthenticatedUser() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    contacts() {
      const value = this.$store.getters["profile/getFriends"];
      value.map((val) => {
        if (val.profile) {
          let userList = {
            label: val.full_name,
            value: val.id,
            key: val.email,
            icon: val.profile_picture,
          };
          this.friends.push(userList);
          return userList;
        }
      });
      return this.friends;
    },
    contactsOptions(){
      console.log("this.topicNonInvitedUsers", this.topicNonInvitedUsers)
      return this.topicNonInvitedUsers.map(option=>({...option, isChecked: false}))
    },
    randomId() {
      const currentDate = new Date();
      const timestamp = currentDate.getTime();
      return timestamp;
    },
    audienceChoice(){
      return this.selectedTopic?.is_private ? 'private' : 'public'
    },
    topicDetails() {
      return this.$store.getters["article/getInterestGroup"];
    },
    users() {
      return this.topicDetails[0]
    },
    preSelectedUsers(){
      if (this.topicDetails.length > 0) {
        const created_by = this.users?.created_by
        const admins = this.users?.admins.map(user=>({...user, role:'admin', status:'active', created_by}))
        const editors = this.users?.editors.map(user=>({...user, role:'editor', status:'active', created_by}))
        const contributors = this.users?.contributors.map(user=>({...user, role:'contributor', status:'active', created_by}))
        const pending_invitations_admins = this.users?.pending_invitations_admins.map(user=>({...user, role:'admin', status:'pending', created_by}))
        const pending_invitations_editors = this.users?.pending_invitations_editors.map(user=>({...user, role:'editor', status:'pending', created_by}))
        const pending_invitations_contributors = this.users?.pending_invitations_contributors.map(user=>({...user, role:'contributor', status:'pending', created_by}))
        return [...admins, ...editors, ...contributors, ...pending_invitations_admins, ...pending_invitations_editors, ...pending_invitations_contributors]
      }
      else{
        return []
      }
    },
    
  },
  emits: ["handle-close", "show-success-modal"],
  watch: {
    emails(value) {
      if (value) {
        this.FieldErr = false;
      }
    },
    selectedUsers(value) {
      if (value) {
        this.FieldErr = false;
      }
    },
    visible(val) { 
      this.emitter.emit('clear-tagify-contacts')
      if (val) { 
       this.emptyTagifyInput = false
       if (this.$refs.addNewTopicBody) {
          this.$refs.addNewTopicBody.addEventListener('click', (event)=>{
              // used to handle click inside of this component
              const element = this.$refs.manageTopicRolesOnInviteTopicCollaboration
              const className ='manage-topics-roles-section__section--search-users-dropdown'

              if (element){
                if (element.$el.contains(event.target)) {
                  const targetElement = event.target;

                  // Check if the clicked element or any of its ancestors has the specific class
                  if (targetElement.classList.contains(className) || targetElement.closest(`.${className}`)) {
                    //pass
                  } else {
                    // If clicked outside of the element or inside it but without the class, hide the dropdown
                    element.hideDropdown(); // Assuming element has the hideDropdown method
                  }
                }else{
                  element.hideDropdown();
                }
              }
            })
        }

        if (this.inviteType === 'topicInvite'){
          (async () => {
                this.skeletonLoader = true
                await this.getTopicGroupDetaiils()
                await this.fetchUninvitedTopicUsers()
                this.skeletonLoader = false
            })();

          console.log("INVITE", this.inviteType)
        }

      }else{
        this.setActiveFolder()
      }
    }
  },
  data() {
    return {
      contactOptions: [],
      selectedUsers: [],
      onUsersRequest: false,
      emails: [],
      loader: false,
      topicFieldErr: false,
      FieldErr: false,
      isSubmitted:false,
      friends: [],
      emptyTagifyInput: false,
      inviteMessage: '',
      newlyAddedTopicMembers: [],
      updatedTopicMembers: [],
      skeletonLoader: false,
      searchUserLoader:false
    };
  },

  methods: {
    ...mapActions({
      inviteToFolders: 'folders/inviteToFolders',
      setActiveFolder: 'folders/setActiveFolder',
      fetchUninvitedTopicUsers: 'discover/fetchUninvitedTopicUsers',
      
    }),
    closeModal() {
      this.emails = [];
      this.selectedUsers = [];
      this.$emit("handle-close", false);
      this.FieldErr = false;
      this.emptyTagifyInput=true
      this.clearAllFields()
    },
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
    async fetchAllUsers(value) {
      console.log("HELLLO")
      try {
        console.log(value, "FETCH ALL USERS")
        this.contactOptions = [];
        this.debounce(async () => {
          const payload = {
            full_name: value,
          };
          const response = await this.$store.dispatch(
            "profile/getUsersList",
            payload
          );
          if (response.status == 200) {
            response.data.map(async (val) => {
              if (val.profile) {
                let userList = {
                  label: val.profile.full_name,
                  value: val.id,
                  key: val.email,
                  icon: val.profile.profile_picture,
                };
                this.contactOptions.push(userList);
                await this.$store.commit(
                  "profile/setContacts",
                  this.contactOptions
                );
                return userList;
              }
            });
          }
        }, 1000);
      } catch (err) {
        console.log(err);
      }
    },
    async inviteCategory() {
      if (this.newlyAddedTopicMembers.length === 0 && this.updatedTopicMembers.length === 0 && this.emails.length === 0) {
        this.FieldErr = true;
        return true;
      }
      try {
        this.loader = true;
       
        const newUsersInvitations = this.newlyAddedTopicMembers.map(val => ({
          to_user: val.id,
          permission: val?.role,
          link: `?topic=${this.selectedTopic.interest.replaceAll(" ", "-")}&id=${this.selectedTopic.id}`,
          message: this.inviteMessage
        }));


        const updateUserRoles = this.updatedTopicMembers.filter(user=>user?.status !== 'pending').map(val => ({
          to_user: val.id,
          permission: val?.role,
        }));

        const pendingUserUpdatedRoles = this.updatedTopicMembers.filter(user=>user?.status === 'pending').map(val => ({
          to_user: val.id,
          permission: val?.role,
          link: `?topic=${this.selectedTopic.interest.replaceAll(" ", "-")}&id=${this.selectedTopic.id}`,
          message: this.inviteMessage
        }));

        const invitedEmails = this.emails.map(user=>({
          to_email: user.email,
          permission: user?.role,
          link: `?topic=${this.selectedTopic.interest.replaceAll(" ", "-")}&id=${this.selectedTopic.id}`,
          message: this.inviteMessage
        }))

        if (newUsersInvitations.length > 0 || updateUserRoles.length > 0 || pendingUserUpdatedRoles.length > 0 || invitedEmails.length > 0){

            const payload = {
              interest_group_id: this.interestGroupId,
              "users": updateUserRoles,
              "invitations": [...pendingUserUpdatedRoles, ...newUsersInvitations, ...invitedEmails]
            };

         await this.$store.dispatch(
            "article/inviteUserAndUpdateRoles",
            payload
          );

          this.$showToast({message:'User invited successfully', type:'success'})
          // if (response.status === 201) {
          //   this.selectedUsers = [];
          //   this.emails = [];
          //   this.topicFieldErr = false;
          //   this.FieldErr = false;
          //   this.$emit("show-success-modal");
          // }
          // this.isSubmitted=await true
          // this.isSubmitted=await false
          // this.inviteMessage = ''
          // this.closeModal()
          // this.loader = false;
        }

        
      } catch (err) {
        this.$showToast({message:'Something went wrong. Please try again later.', type:'failure'})
        console.log(err);
      }finally{
        this.closeModal()
      }
    },
    async inviteToFolder(){
      this.inviteUsers( async (invitationList)=>{

        try{
          await this.inviteToFolders({folderId:this.categoryId, invitationList})
          this.selectedUsers = [];
          this.emails = [];
          this.topicFieldErr = false;
          this.FieldErr = false;
          this.emitter.emit('clear-tagify-contacts')
          // this.$emit("show-success-modal");
          this.closeModal()
          this.loader = false;
          this.$showToast({message:"User invited successfully", type:'success'})
        }
        catch(err){
          this.emitter.emit('clear-tagify-contacts')
          this.closeModal()
          this.loader = false;
          this.$showToast({message:"Something went wrong. Please try again later.", type:'failure'})
        }

      }, 'folderInvite')
    },
    inviteUsers(fn, inviteType){
      if (this.emails == "" && this.selectedUsers.length===0) {
        this.FieldErr = true;
        return true;
      }

      this.loader = true
      const invitationList = this.createInvitationList(this.selectedUsers, this.emails, inviteType)

      return fn(invitationList)
    },
    createInvitationList(selectedUsers, emails, invitationType){
      /**
       * Creating invitation list for selected user and email user 
       * 
       */

      const permission = 'member'
      const link = invitationType === 'topicInvite' ? `?topic=${(this.selectedTopic.interest).replaceAll(" ","-")}&id=${this.selectedTopic.id}` : window.location.href

      let users = selectedUsers.map(user=>({
        to_user: parseInt(user.value),
        permission,
        link
      }))

      const emailedUsers = emails.map(email=>({
          email,
          to_user:null,
          permission,
          link
        }))

      if (invitationType === 'topicInvite')
        users = users.map(invites=>({...invites, email: null})) 

      return [...users, ...emailedUsers ]
      
    },
    fetchedSelection(val){
      this.selectedUsers=val
    },
    fetchedEmail(val){
      this.emails=val
    },
    
    handleClickOutside(){
      // used to handle click out side of this component
      const element =  this.$refs.manageTopicRolesOnInviteTopicCollaboration
      if (element){
        element.hideDropdown()
      }
    },
    
    fetchNewlyAddedTopicMembers(members){
      this.newlyAddedTopicMembers = [...members]
    },
    fetchUpdateTopicMembers(members){
      this.updatedTopicMembers = [...members]
    },
    async getTopicGroupDetaiils() {
      const payload = {
        interest_id: this.selectedTopic.id,
        is_private: this.selectedTopic?.is_private,
      };
      await this.$store.dispatch(
        "article/topicGroupDetails",
        payload
      );
    },
    clearAllFields(){
      this.inviteMessage = ''
      this.newlyAddedTopicMembers = []
      this.updatedTopicMembers = []
      this.topicFieldErr = false;
      this.FieldErr = false;
      this.loader = false;
      this.loader = false;
      this.emitter.emit('clear-tagify-contacts')
      this.emitter.emit('clear-manage-topic-roles')
      // this.emitter.emit('clear-tagify-contacts-tags')
      this.emitter.emit('clear-topic-invited-emails')
    },
    async searchUser(searchValue) {
      try{
        this.searchUserLoader = true
        await this.fetchUninvitedTopicUsers({search:searchValue})
        this.searchUserLoader = false
      }catch(err){
        console.log(err)
      }finally{
        this.searchUserLoader = false
      }
    }
  },
};
</script>
<style lang="scss">
.invite-category-modal {
  .ant-modal {
    width: 50rem !important;
    top: 8rem;
  }
  .ant-modal-content {
    padding: 0;
    box-shadow: 0px 0px 94px #00000047;
    background: #f6f8ff;
    border-radius: 0;
    .ant-modal-close {
      margin: 2.5rem 1.7rem 0 0;
    }
    .ant-modal-header {
      display: none;
    }
    .ant-modal-body {
      .invite-category {
        &__title {
          font-size: 2.4rem;
          font-family: $font-secondary-bold;
          line-height: normal;
          margin-bottom: 0;
          padding: 2.5rem 2.5rem 2.8rem;
          color: $color-black;
        }
        &__skeleton {
          padding: 2.5rem;
          &--input-skeleton {
            margin-bottom: 2rem;
            .ant-skeleton-content {
              .ant-skeleton-title {
                margin: 0;
                height: 4rem;
              }
            }
          }
          &--user-skeleton {
            margin-top: 1rem;
            .ant-skeleton-content {
              display: flex;
              align-items: center;
              gap: 1rem;
              .ant-skeleton-title {
                width: 5rem !important;
                height: 5rem;
                border-radius: 100% !important;
                margin: 0;
              }
              .ant-skeleton-paragraph {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                width: calc(100% - 6rem);
                margin: 0;
                li {
                  margin: 0;
                  height: 1.5rem;
                }
              }
            }
          }
        }
        &__body {
          padding: 0 2.5rem 2.5rem;
          height: max-content;
          max-height: calc(100vh - 32rem);
          overflow-y: auto;
          overflow-x: hidden;
          &::-webkit-scrollbar-track {
            background-color: transparent;
          }

          &::-webkit-scrollbar {
            width: 0.4rem;
            background-color: transparent;
            border-radius: 3rem;
          }

          &::-webkit-scrollbar-thumb {
            background-color: $color-primary;
            border-radius: 3rem;
          }
          .manage-topics-roles-section {
            margin: 0;
          }
          .label {
            font-size: 1.6rem;
            font-family: $font-primary-medium;
            margin-bottom: 1rem;
            line-height: 2.2rem;
            width: fit-content;
            color: $color-black;
            span {
              opacity: 0.6;
            }
          }
          .textarea {
            border: 1px solid $color-dark-grey-4;
            font-size: 1.4rem;
            font-family: $font-primary;
            outline: none;
            border-radius: 0.5rem;
            color: $color-black;
            padding: 1rem;
            box-shadow: none;
            resize: none;
            &::placeholder {
              color: $color-placeholder;
            }
          }
        }
        // .tagify {
        //   margin-bottom: 1.5rem;
        // }
        // .one-option-select {
        //   font-size: 1.5rem;
        //   padding: 1.5rem;
        //   height: 4.45rem;
        // }
        .error {
          color: red;
          font-size: 1.5rem;
          font-family: $font-secondary;
          margin: 0.5rem 0 1rem;
        }
        &__footer {
          padding: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .btn {
            font-size: 1.6rem;
            font-family: $font-primary-medium;
            width: 10rem;
            display: block;
            height: 4rem;
            border: none;
            background-color: $color-primary;
            color: $color-white;
            padding: 0;
            span {
              line-height: 1rem;
            }
            .anticon {
              .anticon-spin {
                font-size: 2rem;
                color: $color-primary;
              }
            }
          }
        }
      }
    }
  }
}
</style>
